import type { ShopCapability } from "@hobbyshopify/backend-client";
import { SubtreeController } from "subtree.js/core";
import {
  CapabilityRequestController,
  type CapabilityRequestDeps,
} from "../../sections/capability-request/capability-request-controller";

export type CapabilityGateDeps = CapabilityRequestDeps;

/** What a switched-off feature's routes show: the feature, and the way to ask for it. */
export class CapabilityGateController extends SubtreeController {
  readonly request: CapabilityRequestController;

  constructor(deps: CapabilityGateDeps, capability: ShopCapability) {
    super();
    this.request = this.own(new CapabilityRequestController(this.subtree, deps, capability));
  }
}
